
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2376',
  depVersions: {
  "customer-portal-app": "static-1.2376",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.468",
  "data-fetching-client": "static-1.9687",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25441",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5610",
  "hs-test-utils": "static-1.8033",
  "hub-http": "static-1.6241",
  "hub-http-shared-msw-handlers": "static-1.10014",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18290",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11492",
  "I18n": "static-7.1631",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6483",
  "payment-link-components": "static-1.23601",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7057",
  "quartz-core": "static-1.6276",
  "quartz-i18n": "static-1.732",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10227",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5359",
  "rich-text-lib": "static-1.19868",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18025",
  "ui-components-test-utils": "static-1.5629",
  "UIComponents": "static-3.8438",
  "foundations-assets": "static-1.4888",
  "foundations-components": "static-1.7977",
  "foundations-theming": "static-1.4440",
  "foundations-theming-specialty": "static-1.2156",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.926",
  "quartz-config": "static-1.835",
  "quartz-routing": "static-1.487",
  "quick-fetch": "static-1.3931",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16691",
  "rpc-client-utils": "static-1.4672",
  "sanitize-text": "static-1.8162",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4783",
  "ui-addon-react-router-dom": "static-1.9562",
  "usage-tracker": "static-1.7365",
  "usage-tracker-anonymous": "static-1.5782",
  "usage-tracker-core": "static-1.7215",
  "video-components-external": "static-1.11344",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3413",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3334",
  "quartz-webpack": "static-1.3281",
  "bend-plugin-quartz-routing": "static-1.135",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7690",
  "frontend-preferences-client": "static-1.7947",
  "laboratory-lib": "static-3.7175",
  "onboarding-scopes": "static-1.6481",
  "seat-types-lib": "static-1.59",
  "ui-addon-opt": "static-4.8385",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3144",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.95",
  "ts-schema": "static-1.4094",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7782",
  "cssUtils": "static-1.798",
  "customer-data-ui-utilities": "static-1.9846",
  "HubStyle": "static-2.11799",
  "knowledge-content-types": "static-1.8492",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9908",
  "ui-addon-i18n": "static-1.11168",
  "ui-business-units-lib": "static-1.9074",
  "ui-shepherd-react": "static-3.10188",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4347",
  "commerce-tours-lib": "static-1.6140",
  "customer-data-properties": "static-1.51634",
  "getting-started-shared-tasks": "static-1.18517",
  "growth-onboarding-reliability": "static-1.5102",
  "onboarding-tours": "static-1.16651",
  "reference-resolvers-lite": "static-1.8114",
  "sales-checkout-service-client": "static-1.3661",
  "ui-addon-iframeable": "static-1.9078",
  "user-context": "static-1.5125",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4666",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.732",
  "quartz-head": "static-1.722",
  "quartz-test": "static-1.732",
  "quartz-tracking": "static-1.436",
  "ui-fonts": "static-1.754",
  "usage-tracker-container": "static-1.7355",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9444",
  "data-token-picker": "static-1.16442",
  "FileManagerLib": "static-1.39320",
  "property-translator": "static-1.5419",
  "atom": "static-1.5092",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5948",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5460",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-components": "static-1.4246",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "trellis-assets": "static-1.2010",
  "bend-plugin-foundations-theming": "static-1.2923",
  "foundations-theming-base": "static-1.3425",
  "stylex": "static-1.33",
  "interframe": "static-3.4779",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5779",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.82",
  "chirp-fetch": "static-1.1907",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4496",
  "react-flip-move": "static-1.70",
  "apollo-link-hub-http": "static-2.4671",
  "content-media-composition-data-lib": "static-1.12387",
  "content-media-compositions": "static-2.16394",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4173",
  "magpie-lib": "static-1.5563",
  "magpie-types": "static-1.5023",
  "media-bridge-lib": "static-1.18961",
  "video-data-lib": "static-1.35002",
  "bender-build-tools": "static-1.3215",
  "inbound-db-properties-service-client": "static-1.3861",
  "superstore": "static-1.4781",
  "feedback-loader": "static-1.29333",
  "ai-components-ui-library": "static-1.9035",
  "ui-addon-video-player": "static-1.8722",
  "ui-coaching-tips": "static-1.28621",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4634",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2518",
  "navigation-messaging": "static-1.7426",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8190",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9647",
  "crm-message-bus": "static-1.43040",
  "growth-data-modal": "static-1.5459",
  "hubspot-apollo-client": "static-1.4899",
  "onboarding-tours-client": "static-1.4865",
  "calling-global-api": "static-1.64587",
  "calling-internal-common": "static-1.31322",
  "calling-lifecycle-internal": "static-1.65969",
  "calling-lifecycle-messages": "static-1.58263",
  "conditional-properties-service-client": "static-1.3812",
  "crm-links": "static-1.6314",
  "customer-data-objects-ui-components": "static-1.13048",
  "customer-data-properties-shared-msw-handlers": "static-1.9341",
  "customer-data-property-utils": "static-1.8110",
  "external-options-client-types": "static-1.4174",
  "file-manager-components": "static-1.23680",
  "framework-data-schema-resolvers": "static-1.6904",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.173",
  "inbound-db-meta-service-client": "static-1.3601",
  "inbounddb-objects-service-types": "static-1.4238",
  "meetings-icalendar-utils-lib": "static-1.651",
  "multi-currency-client-types": "static-1.3706",
  "object-builder-ui-client": "static-1.48816",
  "pipeline-validation-client-types": "static-1.3980",
  "property-value-citations": "static-1.2248",
  "pulse": "static-1.596",
  "smart-property-lib": "static-1.7189",
  "tiered-pricing": "static-1.1263",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11010",
  "growth-onboarding-confetti": "static-1.3086",
  "growth-onboarding-next-action-utils": "static-1.1981",
  "navigation-components": "static-1.18099",
  "onboarding-tours-utils": "static-1.717",
  "ui-shepherd-tracker": "static-1.7569",
  "ui-universal-auth": "static-1.9002",
  "batch-promise": "static-1.1561",
  "getting-started-shared-tasks-store": "static-1.17635",
  "hubspotter-http-shared-msw-handlers": "static-1.10012",
  "usage-tracker-session-replay": "static-1.5051",
  "audio-components": "static-1.5945",
  "FileManagerCore": "static-1.39179",
  "FileManagerImages": "static-1.36831",
  "video-components": "static-1.13347",
  "foundations-components-legacy": "static-1.1002",
  "purchase-motions-api": "static-1.5951",
  "signup-constants": "static-1.18879",
  "signup-ui-url-generator": "static-2.8072",
  "trials-service-types": "static-1.3923",
  "usage-tracker-public": "static-1.7176",
  "reactive-lib": "static-1.743",
  "simple-logging-lib": "static-1.3070",
  "chatspot-core": "static-1.21412",
  "ContentUtils": "static-1.68429",
  "copilot-toolkit": "static-1.11187",
  "growth-onboarding-feedback-components": "static-1.6600",
  "commerce-permissions": "static-1.789",
  "customer-data-tracking": "static-1.6909",
  "products-iframe-lib": "static-1.7996",
  "products-ui-components-shared-msw-handlers": "static-1.10396",
  "restore-request-side-panel-lib": "static-1.939",
  "onboarding-data-sync-lib": "static-1.1988",
  "hubspot-apollo-cache": "static-1.358",
  "calling-error-reporting": "static-1.31329",
  "shared-worker-versioning": "static-1.11056",
  "calling-usage-tracker": "static-1.6561",
  "self-service-api": "static-1.10267",
  "voice-sms-access-library": "static-1.1064",
  "conversations-skeleton-state": "static-1.7267",
  "location-customization-utils-lib": "static-1.9327",
  "crm-pipelines-api-client-types": "static-1.4154",
  "fdsr-migration-layer": "static-1.23",
  "framework-builder-read-service-client": "static-1.4020",
  "framework-data-schema-quick-fetch": "static-1.6809",
  "persist-promise": "static-1.3718",
  "bend-plugin-pulse": "static-1.99",
  "directed-graph": "static-1.955",
  "event-emitter": "static-1.967",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.226",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10097",
  "fsm": "static-1.3750",
  "policy-lib": "static-1.6797",
  "react-tinymce": "static-1.55303",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10160",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54429",
  "tinymce-plugins": "static-1.57543",
  "tinymce-themes": "static-1.56399",
  "growth-onboarding-next-action-components": "static-1.2009",
  "user-context-client": "static-1.4632",
  "nest": "static-1.247",
  "unified-auth-core-lib": "static-1.798",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4556",
  "video-embed": "static-1.35836",
  "content-icons-ui": "static-1.2233",
  "social-insights-client-types": "static-1.22180",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4832",
  "integrations-lib": "static-1.16217",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4279",
  "InboxConnectUtils": "static-4.14874",
  "meetings-connect-utils-lib": "static-1.7625",
  "calling-orchestration-schema": "static-1.35841",
  "crm-record-cards-service-types": "static-1.3612",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4535",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3062",
  "tinymce-data": "static-1.40514",
  "ui-addon-sales-email": "static-1.5230",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12483",
  "layout-dnd-utils": "static-1.11458",
  "react-codemirror": "static-1.10646",
  "ui-brand-identity-lib": "static-1.15368",
  "NamespacedHubStyle": "static-2.9073",
  "outpost": "static-1.4200",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13632",
  "integrations-tracking-lib": "static-1.5621",
  "native-integrations-shared-strings": "static-1.7801",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10386",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.516",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68504",
  "layout-data-lib": "static-1.9783",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3033",
  "google-sheets-integration-lib": "static-1.303",
  "microsoft-drive-integration-lib": "static-1.431",
  "slack-ui-library": "static-1.10412",
  "advanced-menus-core": "static-1.15159",
  "advanced-menus-lib": "static-1.12097",
  "ExportDialog": "static-6.10405",
  "ui-memberships-settings-lib": "static-1.34106",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15158",
  "simple-menus-lib": "static-1.16675"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2376",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.468",
  "data-fetching-client": "/data-fetching-client/static-1.9687",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25441",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5610",
  "hs-test-utils": "/hs-test-utils/static-1.8033",
  "hub-http": "/hub-http/static-1.6241",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10014",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18290",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11492",
  "I18n": "/I18n/static-7.1631",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6483",
  "payment-link-components": "/payment-link-components/static-1.23601",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7057",
  "quartz-core": "/quartz-core/static-1.6276",
  "quartz-i18n": "/quartz-i18n/static-1.732",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10227",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5359",
  "rich-text-lib": "/rich-text-lib/static-1.19868",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18025",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5629",
  "UIComponents": "/UIComponents/static-3.8438",
  "foundations-assets": "/foundations-assets/static-1.4888",
  "foundations-components": "/foundations-components/static-1.7977",
  "foundations-theming": "/foundations-theming/static-1.4440",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2156",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.926",
  "quartz-config": "/quartz-config/static-1.835",
  "quartz-routing": "/quartz-routing/static-1.487",
  "quick-fetch": "/quick-fetch/static-1.3931",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16691",
  "rpc-client-utils": "/rpc-client-utils/static-1.4672",
  "sanitize-text": "/sanitize-text/static-1.8162",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4783",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9562",
  "usage-tracker": "/usage-tracker/static-1.7365",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5782",
  "usage-tracker-core": "/usage-tracker-core/static-1.7215",
  "video-components-external": "/video-components-external/static-1.11344",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3413",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3334",
  "quartz-webpack": "/quartz-webpack/static-1.3281",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.135",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7690",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7947",
  "laboratory-lib": "/laboratory-lib/static-3.7175",
  "onboarding-scopes": "/onboarding-scopes/static-1.6481",
  "seat-types-lib": "/seat-types-lib/static-1.59",
  "ui-addon-opt": "/ui-addon-opt/static-4.8385",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3144",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.95",
  "ts-schema": "/ts-schema/static-1.4094",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7782",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9846",
  "HubStyle": "/HubStyle/static-2.11799",
  "knowledge-content-types": "/knowledge-content-types/static-1.8492",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9908",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11168",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9074",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10188",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4347",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6140",
  "customer-data-properties": "/customer-data-properties/static-1.51634",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18517",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5102",
  "onboarding-tours": "/onboarding-tours/static-1.16651",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8114",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3661",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9078",
  "user-context": "/user-context/static-1.5125",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4666",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.732",
  "quartz-head": "/quartz-head/static-1.722",
  "quartz-test": "/quartz-test/static-1.732",
  "quartz-tracking": "/quartz-tracking/static-1.436",
  "ui-fonts": "/ui-fonts/static-1.754",
  "usage-tracker-container": "/usage-tracker-container/static-1.7355",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9444",
  "data-token-picker": "/data-token-picker/static-1.16442",
  "FileManagerLib": "/FileManagerLib/static-1.39320",
  "property-translator": "/property-translator/static-1.5419",
  "atom": "/atom/static-1.5092",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5948",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5460",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4246",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "trellis-assets": "/trellis-assets/static-1.2010",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2923",
  "foundations-theming-base": "/foundations-theming-base/static-1.3425",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4779",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5779",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.82",
  "chirp-fetch": "/chirp-fetch/static-1.1907",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4496",
  "react-flip-move": "/react-flip-move/static-1.70",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4671",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12387",
  "content-media-compositions": "/content-media-compositions/static-2.16394",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4173",
  "magpie-lib": "/magpie-lib/static-1.5563",
  "magpie-types": "/magpie-types/static-1.5023",
  "media-bridge-lib": "/media-bridge-lib/static-1.18961",
  "video-data-lib": "/video-data-lib/static-1.35002",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3861",
  "superstore": "/superstore/static-1.4781",
  "feedback-loader": "/feedback-loader/static-1.29333",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8722",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28621",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4634",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2518",
  "navigation-messaging": "/navigation-messaging/static-1.7426",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8190",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9647",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "growth-data-modal": "/growth-data-modal/static-1.5459",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4899",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4865",
  "calling-global-api": "/calling-global-api/static-1.64587",
  "calling-internal-common": "/calling-internal-common/static-1.31322",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65969",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58263",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3812",
  "crm-links": "/crm-links/static-1.6314",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13048",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9341",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8110",
  "external-options-client-types": "/external-options-client-types/static-1.4174",
  "file-manager-components": "/file-manager-components/static-1.23680",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6904",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.173",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3601",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4238",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.651",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3706",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48816",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3980",
  "property-value-citations": "/property-value-citations/static-1.2248",
  "pulse": "/pulse/static-1.596",
  "smart-property-lib": "/smart-property-lib/static-1.7189",
  "tiered-pricing": "/tiered-pricing/static-1.1263",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11010",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3086",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1981",
  "navigation-components": "/navigation-components/static-1.18099",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.717",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7569",
  "ui-universal-auth": "/ui-universal-auth/static-1.9002",
  "batch-promise": "/batch-promise/static-1.1561",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17635",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10012",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5051",
  "audio-components": "/audio-components/static-1.5945",
  "FileManagerCore": "/FileManagerCore/static-1.39179",
  "FileManagerImages": "/FileManagerImages/static-1.36831",
  "video-components": "/video-components/static-1.13347",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1002",
  "purchase-motions-api": "/purchase-motions-api/static-1.5951",
  "signup-constants": "/signup-constants/static-1.18879",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8072",
  "trials-service-types": "/trials-service-types/static-1.3923",
  "usage-tracker-public": "/usage-tracker-public/static-1.7176",
  "reactive-lib": "/reactive-lib/static-1.743",
  "simple-logging-lib": "/simple-logging-lib/static-1.3070",
  "chatspot-core": "/chatspot-core/static-1.21412",
  "ContentUtils": "/ContentUtils/static-1.68429",
  "copilot-toolkit": "/copilot-toolkit/static-1.11187",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6600",
  "commerce-permissions": "/commerce-permissions/static-1.789",
  "customer-data-tracking": "/customer-data-tracking/static-1.6909",
  "products-iframe-lib": "/products-iframe-lib/static-1.7996",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10396",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.939",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1988",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.358",
  "calling-error-reporting": "/calling-error-reporting/static-1.31329",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11056",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6561",
  "self-service-api": "/self-service-api/static-1.10267",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1064",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7267",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9327",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4154",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.23",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4020",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6809",
  "persist-promise": "/persist-promise/static-1.3718",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.99",
  "directed-graph": "/directed-graph/static-1.955",
  "event-emitter": "/event-emitter/static-1.967",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.226",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10097",
  "fsm": "/fsm/static-1.3750",
  "policy-lib": "/policy-lib/static-1.6797",
  "react-tinymce": "/react-tinymce/static-1.55303",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10160",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54429",
  "tinymce-plugins": "/tinymce-plugins/static-1.57543",
  "tinymce-themes": "/tinymce-themes/static-1.56399",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2009",
  "user-context-client": "/user-context-client/static-1.4632",
  "nest": "/nest/static-1.247",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.798",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4556",
  "video-embed": "/video-embed/static-1.35836",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "social-insights-client-types": "/social-insights-client-types/static-1.22180",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4832",
  "integrations-lib": "/integrations-lib/static-1.16217",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4279",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14874",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7625",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35841",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3612",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4535",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3062",
  "tinymce-data": "/tinymce-data/static-1.40514",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5230",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12483",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11458",
  "react-codemirror": "/react-codemirror/static-1.10646",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15368",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9073",
  "outpost": "/outpost/static-1.4200",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13632",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5621",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7801",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10386",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.516",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68504",
  "layout-data-lib": "/layout-data-lib/static-1.9783",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3033",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.303",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.431",
  "slack-ui-library": "/slack-ui-library/static-1.10412",
  "advanced-menus-core": "/advanced-menus-core/static-1.15159",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12097",
  "ExportDialog": "/ExportDialog/static-6.10405",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34106",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15158",
  "simple-menus-lib": "/simple-menus-lib/static-1.16675"
}
};
